<div class="dynamic-label-container"
    [ngClass]="['lbl lbl-' + config.labelPosition, config.highlight ? 'dynamic-label-attention' : '']"
    [style.border-style]="config.borderStyle"
    [style.border-width]="config.borderWidth"
    [style.border-radius]="config.borderRadius"
    [style.min-width]="config.minWidth"
    [style.min-height]="config.minHeight"
    [style.font-size]="config.fontSize">
    <div *ngIf="config.iconPath" class="icon-wrapper">
        <img  
        [src]="config.iconPath" 
        class="icon" 
        [ngStyle]="{ width: config.iconWidth, height: config.iconHeight }">
    </div>
    <div *ngIf="data" class="label">
        <label [innerHTML]="data" [style.white-space]="config.whitespace">
        </label>
    </div>
</div>